import svg4everybody from 'svg4everybody';
import 'lazysizes';
import 'objectFitPolyfill';
import './helpers/arrayFromPolyfill';
import ContactPersons from './components/ContactPersons';
import Sidenotes from './components/Sidenotes';
import NewsOverview from './components/NewsOverview';
import Cookie from './components/Cookie';
import Video from './components/Video';
import Navigation from './components/Navigation';
import Search from './components/Search';
import InitVideoGalleryVue from './components/initVideoGalleryVue';

if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

window.getOffsetTop = elem => {
    let el = elem;
    let offsetTop = 0;
    if (el) {
        while (el !== null) {
            if (!Number.isNaN(el.offsetTop)) {
                // const rect = el.getBoundingClientRect();
                offsetTop += el.offsetTop;
            }

            el = el.offsetParent;
        }
        return offsetTop;
    }
    return 0;
};

window.isiPad = navigator.userAgent.match(/iPad/i) != null;
window.isMobileLayout = window.innerWidth < 980;

window.addEventListener('resize', () => {
    window.isMobileLayout = window.innerWidth < 980;
});

window.objectFitPolyfill();

ContactPersons.init();
Cookie.init();
Navigation.init();
Search.init();
Video.init();
InitVideoGalleryVue.init();
NewsOverview.init();
Sidenotes.init();

window.addEventListener('load', () => {
    // SVG fallback
    svg4everybody();
});
